import { createApiCall } from 'lib/base';

const DELETE_INVESTMENT_PLANS_API_ID =
  'INVESTCORE/DELETE_INVESTMENT_PLANSL_API';

const apiCall = createApiCall(
  DELETE_INVESTMENT_PLANS_API_ID,
  ({ id, version, payload }) => ({
    endpoint: `/api/admin/employee-programs/${id}/investment-plans/${version}`,
    method: 'DELETE',
    notify: true,
    isReturn: false,
  })
);

export default apiCall;
